import { useHistory, useLocation } from "react-router-dom"

export function useNavigateToPost(
  nadaPath: string | null | undefined,
  options?: { albumPath?: string; songId?: number },
) {
  const history = useHistory()
  const location = useLocation()

  const navigateToPostScreen = (e: React.MouseEvent) => {
    e.preventDefault()
    const state = { from: location }
    if (options?.albumPath && options?.songId != null) {
      const sep = options.albumPath.includes("?") ? "&" : "?"
      history.push(`${options.albumPath}${sep}song_id=${options.songId}`, state)
    } else if (nadaPath) {
      history.push(nadaPath, state)
    }
  }

  return navigateToPostScreen
}
